<template>
  <div>

    <b-col cols="12">
      <b-card-code>
        <b-card-title>Latest Activity</b-card-title>
        <div
            class="log-scrollable"
            ref="scrollContainer"
            @scroll="handleScroll"
        >
          <b-card>
            <app-timeline>
              <app-timeline-item
                  v-for="(log, index) in taskActivityLog"
                  :key="index"
                  variant="primary"
              >
                <div
                    class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                >
                  <span v-html="formatLogTitle(log)"></span>

                  <small class="text-muted">{{
                      formatDateTime(log?.created_at)
                    }}</small>
                </div>
                <p v-html="formatLogDescription(log)"></p>
              </app-timeline-item>

              <div v-if="loading" class="text-center my-2">
                <b-spinner small label="Loading..." />
              </div>

            </app-timeline>
          </b-card>
        </div>
      </b-card-code>
    </b-col>

  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BButtonToolbar,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormSelect,
  BLink,
  BListGroup,
  BListGroupItem,
  BModal,
  BPagination,
  BRow,
  BSpinner, BTab, BTabs,
  VBTooltip,
} from 'bootstrap-vue'
import {VueGoodTable} from "vue-good-table";
import Ripple from "vue-ripple-directive";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {mapGetters} from "vuex";
import {
  MILESTONE_BOARD_CREATE,
  MILESTONE_BOARD_DELETE,
  MILESTONE_BOARD_EDIT,
  MILESTONE_BOARD_SEE_ALL,
  MILESTONE_BOARD_UPDATE_STATUS,
} from "@/helpers/permissionsConstant"
import LvColorPicker from "lightvue/color-picker";
import {milestoneTaskBoardStatusConstants} from "@/helpers/constant/milestoneTaskBoardStatusConstant.js";
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import flatPickr from 'vue-flatpickr-component'
import {
  milestoneBoardTypeConstants as milestoneBoardTypeConstant
} from "@/helpers/constant/milestoneBoardTypeConstant.js";
import UserSelect from '@/layouts/components/UserSelect.vue'
import UserCard from '@/layouts/components/UserCard.vue'
import {formatDateRange} from '@/helpers/helpers'
import { required, max, size, ext, max_value, min_value } from "@validations";
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import BCardCode from '@core/components/b-card-code'
import { priorityOptionConstants } from "@/helpers/constant/priorityOptionConstant";

export default {
  name: "DashboardActivityLog",
  components: {
    BTabs,
    BCardCode,
    BTab,
    AppTimeline,
    AppTimelineItem,
    UserCard,
    UserSelect,
    LvColorPicker,
    BForm,
    BRow,
    BCol,
    BButton,
    BButtonGroup,
    BButtonToolbar,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BBadge,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BLink,
    BListGroup,
    BListGroupItem,
    BFormDatepicker,
    BFormRadio,
    BFormCheckbox,
    flatPickr,
    BCardActions
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },

  props: {
    members: {
      type: Array,
      required: true // or false if it's optional
    },
    viewAs: {
      type: String,
      default: 'employee',
    }
  },

  data() {
    return {

      priorityOptionConstants,

      taskActivityLog: [],

      currentPage: 1,
      perPage: 5,
      lastPage: false,
      loading: false,

    };
  },
  computed: {
  },

  mounted() {
    this.loadActivityLog();
  },

  methods: {

    getTaskPageUrl(board,id, task) {
      return this.$router.resolve({ name: "admin-board-task-details", params: {
          board,
          id,
          task,
        } }).href;
    },

    getSubTaskPageUrl(board, taskId, task, id, subtask) {
      return this.$router.resolve({ name: "admin-board-task-subtask-details", params: {
          board,
          taskId,
          task,
          id,
          subtask,
        } }).href;
    },



    handleScroll(event) {
      const scrollContainer = event.target;
      const bottomReached =
          scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 10;

      console.log(bottomReached)

      if (bottomReached && !this.loading) {
        this.loadActivityLog(); // Load more when bottom is reached
      }
    },

    async loadActivityLog() {
      if (this.loading || this.lastPage) return;

      this.loading = true;
      try {
        const response = await this.$api.get(`api/task-dashboard/activity-log?view=${this.viewAs}`, {
          params: {
            page: this.currentPage,
            per_page: this.perPage,
          },
        });

        const { data, meta } = response.data;

        this.taskActivityLog.push(...data);
        this.currentPage++;

        if (this.currentPage > meta.last_page) {
          this.lastPage = true;
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error loading activity log",
            icon: "AlertCircleIcon",
            variant: "danger",
            text: error?.response?.data?.message ?? error.message,
          },
        });
      } finally {
        this.loading = false;
      }
    },

    async getTaskActivityLog() {
      return await this.$api.get(
          `api/task-dashboard/activity-log`
      );
    },
    formatLogTitle(logEntry) {
      const { event, log_name, properties } = logEntry;
      const eventCreatedBy = this.eventCreatedBy(logEntry) ? ` by ${this.eventCreatedBy(logEntry)}` : '';

      // Helper to get board ID from available properties
      const getBoardId = (item) => {
        return item?.milestone_task_board_id ||
            (properties.old || {})?.milestone_task_board_id;
      };

      // Only create link if ALL required data exists
      const createTaskLink = (taskData, cssClass = 'text-primary') => {
        if (!taskData || !taskData.id || !taskData.title) {
          return taskData?.title
              ? `<span class="font-weight-bold ${cssClass}">${taskData.title}</span>`
              : 'this task';
        }

        const boardId = getBoardId(taskData);
        if (!boardId) {
          return `<span class="font-weight-bold ${cssClass}">${taskData.title}</span>`;
        }

        return `<a href="${this.getTaskPageUrl(boardId, taskData.id, taskData.title)}"
          class="font-weight-bold ${cssClass}">
          ${taskData.title}
        </a>`;
      };

      // Create subtask link only with complete data
      const createSubtaskLink = (subtaskData, cssClass = 'text-primary') => {

        if (!subtaskData || !subtaskData.id || !subtaskData.title) {
          return subtaskData?.title
              ? `<span class="font-weight-bold ${cssClass}">${subtaskData.title}</span>`
              : 'this subtask';
        }

        const boardId = getBoardId(subtaskData);
        const parentTaskId = subtaskData.task_id;
        const parentTaskShortTitle = subtaskData?.task?.short_title;

        if (!boardId || !parentTaskId) {
          return `<span class="font-weight-bold ${cssClass}">${subtaskData.title}</span>`;
        }

        return `<a href="${this.getSubTaskPageUrl(boardId, parentTaskId, parentTaskShortTitle, subtaskData.id, subtaskData.short_title)}"
          class="font-weight-bold ${cssClass}">
          ${subtaskData.title}
        </a>`;
      };

      // Format user mentions
      const formatUser = (user, cssClass = 'text-primary') => {
        if (!user) return 'someone';
        const userName = user.name || 'Unknown';
        const userEmail = user.email ? `(${user.email})` : '';
        return `<span class="font-weight-bold ${cssClass}">${userName} ${userEmail}</span>`;
      };

      // Get current and old data
      const current = properties.attributes || {};
      const old = properties.old || {};

      // Determine if comment is on task or subtask
      const getCommentTarget = (cssClass = 'text-primary') => {
        // Check if comment is explicitly marked as being on a subtask
        if (current.commentable_type === 'sub_tasks' || old.commentable_type === 'sub_tasks') {
          return createSubtaskLink(current.commentable_type === 'sub_tasks' ? current : old, cssClass);
        }
        // Fallback to checking for subtask indicators
        if (current.task_id || current.parent_id || old.task_id || old.parent_id) {
          return createSubtaskLink(current.task_id ? current : old, cssClass);
        }
        // Default to task link
        return createTaskLink(current, cssClass);
      };

      // Main log formatting
      switch (`${event}:${log_name}`) {
        case 'created:tasks':
          return `Task ${createTaskLink(current)} was created${eventCreatedBy}`;

        case 'created:sub_tasks':
          return `Subtask ${createSubtaskLink(current)} was added${eventCreatedBy}`;

        case 'created:comments':
          return `${formatUser(current.createdBy)} commented on ${getCommentTarget()}${eventCreatedBy}`;

        case 'updated:tasks':
          return `Task ${createTaskLink(current, 'text-warning')} was updated${eventCreatedBy}`;

        case 'updated:sub_tasks':
          return `Subtask ${createSubtaskLink(current, 'text-warning')} was updated${eventCreatedBy}`;

        case 'updated:comments':
          return `${formatUser(current.createdBy, 'text-warning')} updated their comment on ${getCommentTarget('text-warning')}${eventCreatedBy}`;

        case 'deleted:tasks':
          return `Task ${createTaskLink(old, 'text-danger')} was deleted${eventCreatedBy}`;

        case 'deleted:sub_tasks':
          return `Subtask ${createSubtaskLink(old, 'text-danger')} was deleted${eventCreatedBy}`;

        case 'deleted:linked_tasks':
          return `Linked task ${createTaskLink(old, 'text-danger')} was removed${eventCreatedBy}`;

        case 'deleted:comments':
          return `${formatUser(old.createdBy, 'text-danger')} deleted their comment from ${getCommentTarget('text-danger')}${eventCreatedBy}`;

        default:
          if (log_name === 'default' && logEntry.description === 'Task Team Assign Activity Logged') {
            return `Assignment was updated for ${createTaskLink(current)}${eventCreatedBy}`;
          }
          return `Activity: ${event} on ${log_name}${eventCreatedBy}`;
      }
    },

    formatDateTime(value) {
      if (value) {
        return this.$moment(value).format("MMM Do YY, h:mm:ss a");
      }
    },

    formatLogDescription(value) {
      let description = "";
      if (value?.event != "created") {
        if (value?.event == "updated") {
          //showing task update (Phase and Priority) activity log
          if (value?.log_name == "tasks") {
            if (
                value?.properties?.old?.phase_id !=
                value?.properties?.attributes?.phase_id
            ) {
              description = `Phase updated from <span class="font-weight-bold text-warning">${value?.properties?.old?.phase?.title} </span> to  <span class="font-weight-bold text-warning">${value?.properties?.attributes?.phase?.title} </span> <br>`;
            }

            if (
                value?.properties?.old?.priority !=
                value?.properties?.attributes?.priority
            ) {
              const oldPriorityName = this.priorityOptionConstants.reduce(
                  (acc, option) => {
                    if (option.value === value?.properties?.old?.priority) {
                      return option.name;
                    }
                    return acc;
                  },
                  ""
              );

              const newPriorityName = this.priorityOptionConstants.reduce(
                  (acc, option) => {
                    if (
                        option.value === value?.properties?.attributes?.priority
                    ) {
                      return option.name;
                    }
                    return acc;
                  },
                  ""
              );

              description =
                  description +
                  `Priority updated from <span class="font-weight-bold text-warning">${oldPriorityName} </span> to  <span class="font-weight-bold text-warning">${newPriorityName} </span>`;
            }
          }

          if (value?.log_name == "comments") {
            description = "[Previous]";
            description = description + value?.properties?.old?.description;

            description = description + "[Updated]";
            description =
                description + value?.properties?.attributes?.description;
          }
        }

        if (value?.event == "deleted") {
          if (value?.log_name == "comments") {
            description = "[Deleted]";
            description = description + value?.properties?.old?.description;
          }
        }

        if (value?.log_name === "default") {
          if (value?.description == "Task Team Assign Activity Logged") {
            let removedMembers = value?.properties?.removed_members || [];

            if (removedMembers.length > 0) {
              for (let i = 0; i < removedMembers.length - 1; i++) {
                description =
                    description +
                    `<span class="font-weight-bold text-danger">${removedMembers[i].name} (${removedMembers[i]?.email})</span>, `;
              }

              description =
                  description +
                  `<span class="font-weight-bold text-danger">${
                      removedMembers[removedMembers.length - 1].name
                  } (${
                      removedMembers[removedMembers.length - 1]?.email
                  })</span> were removed from the Task. <br><br>`;
            }

            let addedMembers = value?.properties?.added_members || [];

            if (addedMembers.length > 0) {
              for (let i = 0; i < addedMembers.length - 1; i++) {
                description =
                    description +
                    `<span class="font-weight-bold text-warning">${addedMembers[i].name} (${addedMembers[i]?.email})</span>, `;
              }

              description =
                  description +
                  `<span class="font-weight-bold text-warning">${
                      addedMembers[addedMembers.length - 1].name
                  } (${
                      addedMembers[addedMembers.length - 1]?.email
                  })</span> were assigned to the Task.`;
            }
          }
        }
      }

      if (value?.event == "created") {
        if (value?.log_name == "comments") {
          description = description + "[New Comment]";
          description =
              description + value?.properties?.attributes?.description;
        }
      }

      return description;
    },
    eventCreatedBy(value) {
      if (value.causer_type === "App\\Models\\User") {
        // Show name
        const filteredMembers = this.members.filter((member) => {
          return member.id === value.causer_id;
        });

        const createdUserNames = filteredMembers
            .map((member) => member.name)
            .join(", ");

        return createdUserNames;
      }

      return false;
    },

  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/pages/ui-feather.scss";

.table-custom-style {
  font-size: 13px !important;
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    //vertical-align: middle !important;
    text-align: left !important;
  }
}
.table-cell-margin {
  margin: 8px 0px;
}
.second-layer-margin {
  margin-top: 15px;
}

.required-label label::after {
  content: " *";
  color: red;
}

.log-scrollable {
  min-height: 50vh;
  max-height: 50vh;
  overflow-y: scroll;
}
</style>
